import instance from "@/services/api";

export const checkListModalAPI = {
  async getPhotos(client_request_id, check_list_id) {
    return await instance().get(`/client_request/${client_request_id}/check_list/${check_list_id}/photos/read/`).then(res => res?.data)
  },
}